import { render } from "./detail-dokumen.vue?vue&type=template&id=0dce9261&ts=true"
import script from "./detail-dokumen.vue?vue&type=script&lang=ts"
export * from "./detail-dokumen.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__